const Badge = ({ text, tone = 'neutral' }) => {
  const toneClass = {
    neutral: 'bg-slate-100 text-slate-700 border-slate-200',
    blue: 'bg-blue-100 text-blue-700 border-blue-200',
    green: 'bg-green-100 text-green-700 border-green-200',
    red: 'bg-red-100 text-red-700 border-red-200'
  }[tone]

  return (
    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs border ${toneClass}`}>
      {text}
    </span>
  )
}

export default Badge
